<style scoped lang="scss">
.grid {
    margin-right: -30px;
}
/* clear fix */
.grid:after {
  content: '';
  display: block;
  clear: both;
}

.grid-item {
  float: left;
}

</style>

<template>
    <div>
        <slot name="filter" :bus="bus" :current="current"></slot>

        <div :id="id" class="grid">
            <slot name="list" :imageCallback="imageCallback"></slot>
        </div>
    </div>
</template>

<script>
    import Isotope from 'isotope-layout';

    export default {

        data() {
            return {
                id: '',
                iso: null,
                bus: new Vue,
                current: null,
            };
        },

        created() {
            this.id = 'box_' + Math.random().toString(36).substring(7);
            this.prepareComponent();
        },

        methods: {

            prepareComponent() {
                setTimeout(() => {

                    this.iso = new Isotope( '#' + this.id, {
                        itemSelector: '.grid-item',
                        transitionDuration: '.5s',
                        percentPosition: true,
                        masonry: {
                            columnWidth: '.grid-item'
                        },
                    });

                    this.bus.$on('filter', (argument) => {
                        this.filter(argument)
                        if (argument) {
                            axios.post('/dynamic/categories/' + argument + '/filter');
                        }
                    });

                });
            },

            filter(key) {
                this.current = key;
                if (this.iso) {
                    this.iso.arrange({
                        filter: key ? '.' + key : '',
                    });
                }
            },

            imageCallback(event) {
                this.filter(this.current);
            },

        },

    }
</script>
